module.exports = __webpack_public_path__ + "img/website-store-tiles-01-1_low_lay-flat-albums.0b749e47.jpeg";